import * as React from 'react';

import { SpaceContext } from '../../Components';

/**
 * Hook to get the context of the space screen.
 * DO NOT USE THIS HOOK OUTSIDE OF THE Screens/Space folder.
 */
export function useSpaceContext() {
    const context = React.useContext(SpaceContext);
    if (!context) {
        throw new Error('useSpaceContext must be used within a SpaceContextProvider');
    }
    return context;
}
